import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { ILinkedIssueOverview } from '@common/interfaces/linkedIssueOverview';

export interface LinkedIssueOverviewState extends EntityState<ILinkedIssueOverview, string> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'linkedIssueOverviews' })
export class LinkedIssueOverviewStore extends EntityStore<LinkedIssueOverviewState> {
  constructor() { super(); }
}
